import {useQuery} from '@tanstack/react-query';
import verticalTagsFetchers from '@/api/fetchers/verticalTags';

/**
 * Custom hook for querying vertical tags
 * @returns Query result with vertical tags data
 */
function useVerticalTagsQuery() {
  return useQuery({
    queryKey: ['verticalTags'],
    queryFn: verticalTagsFetchers.verticalTags,
  });
}

export default useVerticalTagsQuery;
